import { render, staticRenderFns } from "./newsletter-checkbox.vue?vue&type=template&id=f0ca0b84&"
import script from "./newsletter-checkbox.vue?vue&type=script&lang=js&"
export * from "./newsletter-checkbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports